import * as Mutation from './mutation-types'
import { saveVolume } from "@/plugins/jwtService";
import { uniqueKey } from "@/plugins/utils";

export default {

    [Mutation.SET_LOADING](state, loading) {
        state.loading = loading;
    },


    [Mutation.SET_KEY](state) {
        state.key = uniqueKey();
    },

    [Mutation.SET_VOLUME](state, volume) {
        state.volume = volume
        saveVolume(volume);
    },

    [Mutation.SET_IS_PLAYING](state, isPlaying) {
        state.isPlaying = isPlaying
    },

    [Mutation.RECORD_ERRORS](state, errors) {
        state.errors = errors
    },

    [Mutation.CLEAR_ERRORS](state) {
        state.errors = {}
    }
}